import React, { useEffect, useState } from 'react';
import { trackFbEvent } from '../utils/fbpixel';
type SelectedOption = 'standard' | 'vip';
function useCountdown() {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return time;
}
export function ClosingCTA() {
  const [selected, setSelected] = useState<SelectedOption>('vip');
  const t = useCountdown();
  const checkoutUrl = selected === 'standard' ? 'https://biologiafemenina.com.ar/checkouts/cn/hWNAyoSYZJTJbTg7kMIErTs2/es-ar?_r=AQABYH4AJEYbldjv1X8ikRhvCxTQaIS18_dlVcs3rsXEGpw' : 'https://biologiafemenina.com.ar/checkouts/cn/hWNAyoLK7WK3TzXI3v5RGX0k/es-ar?_r=AQABT_wKLpoN4NHawYiBZBU4FMM4DkBu3EjImLlsMOvhfHk';
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section id="compra" className="relative w-full bg-[#0D0D0D]" data-id="element-21">
      {/* ═══ TIMER BANNER ═══ */}
      <div className="w-full py-2 px-3 text-center" style={{
      background: '#FF006E'
    }} data-id="element-22">
        <div className="flex items-center justify-center gap-2" data-id="element-23">
          <span data-id="element-24">⚡</span>
          <span className="text-white text-[10px] font-bold uppercase tracking-wider" data-id="element-25">
            Oferta expira en:
          </span>
          <div className="flex items-center gap-1" data-id="element-26">
            {[{
            v: t.hours,
            l: 'h'
          }, {
            v: t.minutes,
            l: 'm'
          }, {
            v: t.seconds,
            l: 's'
          }].map((item, i) => <span key={i} className="flex items-center gap-0.5" data-id="element-27">
                <span className="bg-black/30 text-white font-bold text-sm px-1.5 py-0.5 rounded tabular-nums" data-id="element-28">
                  {pad(item.v)}
                </span>
                <span className="text-white/70 text-[9px]" data-id="element-29">{item.l}</span>
                {i < 2 && <span className="text-white/50 text-xs mx-0.5" data-id="element-30">:</span>}
              </span>)}
          </div>
        </div>
      </div>

      {/* ═══ MAIN CONTENT ═══ */}
      <div className="px-3 py-4 flex flex-col items-center gap-2.5 max-w-lg mx-auto" data-id="element-31">
        <h2 className="text-[17px] font-bold text-white leading-snug text-center" data-id="element-32">
          Tu cuerpo no está fallado. Solo necesitaba la información correcta.
        </h2>

        <p className="text-brand-muted text-[10px]" data-id="element-33">Elegí tu plan:</p>

        {/* ═══ CARD 1 — STANDARD ═══ */}
        <div onClick={() => setSelected('standard')} className={`w-full max-w-sm rounded-xl overflow-hidden cursor-pointer transition-all duration-200 ${selected === 'standard' ? 'border-2 border-brand-magenta shadow-[0_0_12px_rgba(255,0,110,0.2)]' : 'border border-white/[0.08] opacity-50'}`} style={{
        background: '#1A1A1A'
      }} data-id="element-34">
          <div className="px-3 py-2 flex items-center gap-3" data-id="element-35">
            <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selected === 'standard' ? 'border-brand-magenta bg-brand-magenta' : 'border-white/20'}`} data-id="element-36">
              {selected === 'standard' && <div className="w-1.5 h-1.5 rounded-full bg-white" data-id="element-37" />}
            </div>
            <div className="flex-1 min-w-0" data-id="element-38">
              <span className="text-brand-magenta text-[9px] font-bold uppercase" data-id="element-39">
                ⭐ Sistema Original
              </span>
              <p className="text-white font-bold text-[13px] leading-tight" data-id="element-40">
                Método pH-ZERO
              </p>
              <p className="text-brand-muted text-[10px]" data-id="element-41">6 Tomos + 3 Bonus</p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-42">
              <p className="text-brand-muted text-[10px] line-through" data-id="element-43">
                $49.990
              </p>
              <p className="text-brand-magenta text-lg font-bold leading-tight" data-id="element-44">
                $19.990
              </p>
            </div>
          </div>
        </div>

        {/* ═══ CARD 2 — VIP ═══ */}
        <div onClick={() => setSelected('vip')} className={`w-full max-w-sm rounded-xl overflow-hidden cursor-pointer transition-all duration-200 relative ${selected === 'vip' ? 'shadow-[0_0_15px_rgba(212,175,55,0.2)]' : 'opacity-50'}`} style={{
        background: '#1A1A1A',
        border: selected === 'vip' ? '2px solid #D4AF37' : '1px solid rgba(255,255,255,0.08)'
      }} data-id="element-45">
          <div className="px-3 py-1 text-center" style={{
          background: 'linear-gradient(135deg, rgba(212,175,55,0.2), rgba(212,175,55,0.05))'
        }} data-id="element-46">
            <span className="text-[9px] font-bold uppercase tracking-wider" style={{
            color: '#D4AF37'
          }} data-id="element-47">
              🏆 LA MEJOR OPCIÓN PARA NO FALLAR
            </span>
          </div>
          <div className="px-3 py-2 flex items-center gap-3" data-id="element-48">
            <div className="w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0" style={{
            borderColor: selected === 'vip' ? '#D4AF37' : 'rgba(255,255,255,0.2)',
            backgroundColor: selected === 'vip' ? '#D4AF37' : 'transparent'
          }} data-id="element-49">
              {selected === 'vip' && <div className="w-1.5 h-1.5 rounded-full bg-white" data-id="element-50" />}
            </div>
            <div className="flex-1 min-w-0" data-id="element-51">
              <span className="text-[9px] font-bold uppercase" style={{
              color: '#D4AF37'
            }} data-id="element-52">
                👑 Pack VIP
              </span>
              <p className="text-white font-bold text-[13px] leading-tight" data-id="element-53">
                Libertad Total 💎
              </p>
              <p className="text-brand-muted text-[10px]" data-id="element-54">
                Todo + GPS + Detective
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-55">
              <p className="text-brand-muted text-[10px] line-through" data-id="element-56">
                $89.990
              </p>
              <p className="text-lg font-bold leading-tight" style={{
              color: '#D4AF37'
            }} data-id="element-57">
                $29.990
              </p>
            </div>
          </div>
        </div>

        {/* ═══ CTA BUTTON ═══ */}
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
        content_name: selected === 'vip' ? 'Pack VIP' : 'Sistema Original',
        value: selected === 'vip' ? 29990 : 19990,
        currency: 'ARS'
      })} className="w-full max-w-sm block text-white font-bold text-[14px] rounded-xl py-3 text-center transition-all animate-heartbeat" style={{
        background: 'linear-gradient(135deg, #FF006E 0%, #7B2FBE 100%)',
        boxShadow: '0 0 20px rgba(255,0,110,0.3), 0 0 40px rgba(123,47,190,0.12)'
      }} data-id="element-58">
          {selected === 'vip' ? 'ADQUIRIR PACK LIBERTAD TOTAL AHORA' : 'ADQUIRIR MÉTODO pH-ZERO AHORA'}
          <span className="block text-[10px] font-normal mt-0.5 opacity-80" data-id="element-59">
            {selected === 'vip' ? '$29.990' : '$19.990'} · Acceso Inmediato
          </span>
        </a>

        {/* ═══ DESCRIPTION (below CTA) ═══ */}
        {selected === 'standard' && <div key="d1" className="desc-fade-in w-full max-w-sm" data-id="element-60">
            <div className="bg-brand-magenta/[0.06] border border-brand-magenta/20 rounded-lg p-3 text-left" data-id="element-61">
              <p className="text-white/90 text-[12px] leading-relaxed" data-id="element-62">
                Acceso inmediato al protocolo de erradicación biológica. Incluye
                los 6 Tomos + 3 Bonus. Ideal para quien ya tiene tiempo de
                organizar sus propias comidas.
              </p>
            </div>
          </div>}
        {selected === 'vip' && <div key="d2" className="desc-fade-in w-full max-w-sm" data-id="element-63">
            <div className="rounded-lg p-3 text-left" style={{
          background: 'rgba(212,175,55,0.05)',
          border: '1px solid rgba(212,175,55,0.2)'
        }} data-id="element-64">
              <p className="text-white/90 text-[12px] font-semibold mb-2" data-id="element-65">
                La solución para mujeres con poco tiempo:
              </p>
              <p className="text-[11px] text-brand-muted leading-snug mb-1" data-id="element-66">
                🛒 <strong className="text-white/80" data-id="element-67">GPS NUTRICIONAL:</strong>{' '}
                Plan día por día con lista de súper.
              </p>
              <p className="text-[11px] text-brand-muted leading-snug mb-1" data-id="element-68">
                🔍 <strong className="text-white/80" data-id="element-69">DETECTIVE:</strong>{' '}
                Blindaje contra pareja, ropa y químicos.
              </p>
              <p className="text-[11px] font-bold mt-2" style={{
            color: '#D4AF37'
          }} data-id="element-70">
                Ahorrá $60.000 solo por las próximas 24hs.
              </p>
            </div>
          </div>}

        {/* ═══ TRUST ═══ */}
        <div className="w-full max-w-sm flex items-center justify-center gap-3 text-brand-muted text-[10px]" data-id="element-71">
          <span data-id="element-72">💳 Mercado Pago</span>
          <span data-id="element-73">·</span>
          <span data-id="element-74">🏦 Tarjetas</span>
          <span data-id="element-75">·</span>
          <span data-id="element-76">🔄 Transferencia</span>
        </div>

        <div className="w-full max-w-sm bg-white/[0.03] rounded-lg p-2 border border-white/[0.06] flex items-center gap-2" data-id="element-77">
          <span data-id="element-78">🛡️</span>
          <p className="text-[10px] text-brand-muted" data-id="element-79">
            <strong className="text-white" data-id="element-80">Compra 100% segura</strong> · Datos
            protegidos · Acceso inmediato · 🇦🇷 Argentina
          </p>
        </div>
      </div>
    </section>;
}